import { round } from 'lodash';

export const addIndexToGeoMapData = geographyData => {
  const _geographyData = [...geographyData];
  const totalTargetWt =
    _geographyData && _geographyData.length > 0
      ? _geographyData.map(item => item.tw).reduce((prev, next) => prev + next)
      : 0;
  const totalBaseWt =
    _geographyData && _geographyData.length > 0
      ? _geographyData.map(item => item.bw).reduce((prev, next) => prev + next)
      : 0;

  return _geographyData.map(item => {
    item.i = Number.isNaN(
      round(100 * (item.tw / totalTargetWt) * (totalBaseWt / item.bw))
    )
      ? 0
      : round(100 * (item.tw / totalTargetWt) * (totalBaseWt / item.bw));
    return item;
  });
};

export const populateIndexGroups = (minIndex, maxIndex, requestedGroups) => {
  minIndex = Number(minIndex);
  maxIndex = Number(maxIndex);
  const noOfIndexes = maxIndex - minIndex + 1; // inclusive of both min & max
  const minGroup = Math.trunc(noOfIndexes / 2, 1); // minimum range group is possible with 2 values
  const possibleGroups =
    requestedGroups > minGroup ? minGroup : requestedGroups;
  const range = Math.trunc(noOfIndexes / possibleGroups - 1);
  const minMax = [minIndex, minIndex + range];
  const remainder = noOfIndexes % possibleGroups;
  const rangeGroups = [];

  for (let i = 0; i < possibleGroups; i += 1) {
    rangeGroups.push(`${Math.trunc(minMax[0])} - ${Math.trunc(minMax[1])}`);
    const offset = possibleGroups - i - 1 <= remainder ? 1 : 0; // distribute remainder for higher groups
    minMax[0] = minMax[1] + 1;
    minMax[1] = minMax[0] + range + offset;
  }

  if(minIndex === maxIndex && !rangeGroups.length){
    return [`${minIndex} - ${maxIndex}`];
  }

  return rangeGroups;
};

export const getDropdownListForTableData = (obj1, obj2) => {
  const array = [];
  const objKeys = Object.keys(obj1);
  const ignoreGeographies = ['county', 'zipcode'];
  objKeys.forEach(item => {
    const index = obj2.findIndex(index => index.value === item);
    if (!ignoreGeographies.includes(item)) {
      array.push(obj2[index].label);
    }
  });

  return array;
};

export const getClassIndexFromIndexGroup = (
  index,
  rangeGroupArray,
  excludeMinIndex,
  excludeMaxIndex
) => {
  for (let i = 0; i < rangeGroupArray.length; i += 1) {
    const _iGroup = rangeGroupArray[i].split('-');
    const min = _iGroup[0];
    const max = _iGroup[1];

    if (
      excludeMinIndex &&
      excludeMaxIndex &&
      index >= excludeMinIndex &&
      index <= excludeMaxIndex
    ) {
      return -2;
    }
    if (index >= min && index <= max) {
      return i;
    }
  }
  return -1;
};

export const generateMapLegends = (indexRange, indexGroupCount, colorArray) => {
  const temp = [];

  if (indexRange.length) {
    indexRange.forEach((item, index) => {
      temp.push({
        colorCode: colorArray[indexGroupCount][index],
        indexGroup: item,
      });
    });
  }

  return temp;
};

export const resetDataOnTargetRemove = obj => {
  // eslint-disable-next-line no-undef
  obj = structuredClone(obj);
  const keys = Object.keys(obj);
  keys.forEach(item => {
    obj[item].exclude = false;
    obj[item].excludeMinIndex = '';
    obj[item].excludeMaxIndex = '';
    obj[item].minIndex = undefined;
    obj[item].maxIndex = undefined;
  });
  return obj;
};
